import React, { useEffect, useMemo } from 'react'
import Select, { components } from 'react-select'
import { Controller } from 'react-hook-form'

import './attribute_select_element.scss'

const formatOptions = (values) => {
  return values.map(value => {
    if (!value) return

    return {
      value: value.id,
      label: value.name
    }
  })
}

const emptySizeCondition = (name, options) => {
  if (['attribute_size1', 'attribute_size2'].includes(name)) {
    if (options.length === 1) {
      return true
    }
  }

  return false
}

const AttributeSelectLabel = ({ name }) => {
  return (
    <label htmlFor={`select_${name}`}>
      {name.replace('attribute_', '').replace('_', ' ')}
    </label>
  )
}

const AttributeSelectOption = (props) => {
  const { value } = props
  const { name, selectedValues, selectedValuesMap, attributesFilterExcludeName } = props.selectProps

  const attributesGroupValue = useMemo(() => {
    if (selectedValues['select_' + attributesFilterExcludeName]) {
      return selectedValues['select_' + attributesFilterExcludeName].value
    }

    return null
  }, [selectedValues, attributesFilterExcludeName])

  const attributesGroupMatch = useMemo(() => {
    if (!attributesGroupValue) {
      return null
    }

    const results = []
    for (let index = 0; index < selectedValuesMap.length; index++) {
      const valuesSet = selectedValuesMap[index]
      if (valuesSet.some(valueSet => valueSet.value === attributesGroupValue)) {
        results.push(valuesSet.map(valueSet => valueSet.value))
      }
    }

    return results.flat()
  }, [selectedValuesMap])

  if (!selectedValuesMap || !attributesGroupValue) {
    return <components.Option {...props} />
  }

  const matchSet = attributesGroupMatch.includes(value)
  if (matchSet) {
    props.innerProps.style = {
      ...props.innerProps.style,
      cursor: 'pointer'
    }
  }
  else {
    return <></>
    props.innerProps.style = {
      opacity: '0.7',
      color: '#444',
      backgroundColor: '#eee',
      cursor: 'pointer'
    }
  }

  return <components.Option {...props} />
}

const AttributeSelect = ({
  name,
  options,
  control,
  setValue,
  getValues,
  onChange,
  selectedVariation,
  attributesMap,
  attributesFilterExcludeName }) => {

  // Sync attribute values
  // @todo, animation to alert user?
  useEffect(() => {
    if (!selectedVariation) {
      return
    }

    for (let index = 0; index < options.length; index++) {
      const option = options[index]

      if (selectedVariation.values.includes(option.value)) {
        setValue(`select_${name}`, option)
      }
    }

    /*return () => {
      for (let index = 0; index < options.length; index++) {
        setValue(`select_${name}`, null)
      }
    }*/
  }, [selectedVariation])

  if (name === attributesFilterExcludeName || !attributesFilterExcludeName && name === 'attribute_size') {
    return (
      <>
        <AttributeSelectLabel name={name} />
        <Controller
          name={`select_${name}`}
          control={control}
          render={({ field }) => <Select
            {...field}
            classNamePrefix="select-element"
            options={options}
            isSearchable={false}
            onChange={(value) => {
              field.onChange(value)
              onChange(value)
            }}
            selectedValues={getValues()}
            selectedValuesMap={selectedVariation ? attributesMap : null}
          />}
        />
      </>
    )
  }

  return (
    <>
      <AttributeSelectLabel name={name} />
      <Controller
        name={`select_${name}`}
        control={control}
        render={({ field }) => <Select 
          {...field} 
          classNamePrefix="select-element"
          components={{ Option: AttributeSelectOption }}
          options={options}
          isSearchable={false}
          onChange={(value) => {
            field.onChange(value)
            onChange(value)
          }}
          selectedValues={getValues()}
          selectedValuesMap={selectedVariation ? attributesMap : null}
          attributesFilterExcludeName={attributesFilterExcludeName}
        />}
      />
    </>
  )
}

const AttributeSingle = ({ name, options, selectedVariation }) => {
  const [option] = options

  if (!selectedVariation || !selectedVariation.values.includes(option.id)) {
    return <></>
  }

  return (
    <>
      <AttributeSelectLabel name={name} />
      <div>{option.name}</div>
    </>
  )
}

export const AttributeSelectElement = (props) => {
  const { options, attributesChanged } = props
  const elementClasses = ['attribute-select-element-container']
  if (attributesChanged) {
    elementClasses.push('changed')
  }

  if (options.length === 1) {
    return (
      <div className={elementClasses.join(' ')}>
        <AttributeSingle {...props} options={options} />
      </div>
    )
  }

  if (emptySizeCondition(props.name, options)) {
    return <></>
  }

  return (
    <div className={elementClasses.join(' ')}>
      <AttributeSelect {...props} options={formatOptions(options)} />
    </div>
  )
}
